import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { DataCharts } from 'src/app/model/installation/charts.model';
import { Installation } from 'src/app/model/installation/installation.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-weekly-distribution',
  templateUrl: './installation-weekly-distribution.component.html',
  styleUrls: ['./installation-weekly-distribution.component.scss']
})
export class InstallationWeeklyDistributionComponent implements OnInit {

  @Input() installation : any;

  lineChartData: ChartDataSets[] = [];

  lineChartLabels: Label[] = [];
  chartDatas: any[]=[];

  lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };



  lineChartColors: Color[] = [
    {
      borderColor: '#8888e8',
      backgroundColor: 'rgba(255,255,255,0.28)',
      pointBorderColor: '#5555e8',
      pointBackgroundColor: '#5555e8'
    },
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType: ChartType = 'line';

  constructor(private service: InstallationsService) { }

  public charts !: DataCharts;


  ngOnInit(): void {


    if (this.installation) {

      this.service.getChartsData((this.installation.id_backup).toString()).subscribe((charts) => {
        this.charts = charts;

/** This is incorrect. charts.data_chartX[x].ventes_count is not garanteed at all
 * charts.data_chart3[6] ==> charts.data_chart could range from 0 to x, each including N elements.
 * 
 */
for(var i = 0;i<charts.data_chart3.length;i++){
  this.lineChartLabels[i]=charts.data_chart3[i].weekday;
  this.chartDatas[i] = parseFloat(charts.data_chart3[i].ventes_count);
}
 

        this.lineChartData = [
          {
            data: this.chartDatas, label: 'Ventes (%)'
          }
        ]

        // console.log(charts);
        // console.log( parseFloat(charts.data_chart3[0].ventes_count));

      })
    }

  }

}
